import { render, staticRenderFns } from "./TeamSlide.vue?vue&type=template&id=94980328&scoped=true"
import script from "./TeamSlide.vue?vue&type=script&lang=js"
export * from "./TeamSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94980328",
  null
  
)

export default component.exports